<div class="vc-statistics vc-view-shell">
  <main class="vc-statistics__layout vc-view-content">
    <section class="vc-statistics__frame vc-surface-panel">
      <div class="vc-page-toolbar vc-page-toolbar--stacked vc-statistics__toolbar vc-statistics__toolbar--desktop">
        <div class="vc-statistics__header-top">
          <nav class="vc-statistics__nav">
            @for (item of navItems; track item.route) {
              <a
                class="vc-statistics__nav-item"
                [routerLink]="['./', item.route]"
                routerLinkActive="vc-statistics__nav-item--active"
                [routerLinkActiveOptions]="{ exact: item.route === 'dashboard' }"
              >
                <i class="pi" [ngClass]="item.icon"></i>
                <span>{{ item.labelKey | translate }}</span>
              </a>
            }
          </nav>
        </div>

        <div class="vc-statistics__filters-row">
          <div class="vc-statistics__date-display">
            <button
              class="vc-statistics__period-btn"
              [disabled]="!canShiftPeriod"
              (click)="shiftPeriod('previous')"
              [pTooltip]="'STATISTICS.FILTERS.PREVIOUS_PERIOD' | translate"
              tooltipPosition="top"
            >
              <i class="pi pi-angle-left"></i>
            </button>
            <i class="pi pi-calendar"></i>
            <span class="vc-statistics__date-range-text">{{ dateRangeLabel }}</span>
            <button
              class="vc-statistics__period-btn"
              [disabled]="!canShiftPeriod"
              (click)="shiftPeriod('next')"
              [pTooltip]="'STATISTICS.FILTERS.NEXT_PERIOD' | translate"
              tooltipPosition="top"
            >
              <i class="pi pi-angle-right"></i>
            </button>
          </div>

          <div class="vc-statistics__filters">
            <div class="vc-statistics__filter-group">
              @for (preset of datePresets; track preset.value) {
                <button
                  class="vc-statistics__preset-btn"
                  [class.vc-statistics__preset-btn--active]="
                    filters?.activePreset === preset.value
                  "
                  (click)="setPreset(preset.value)"
                >
                  {{ preset.labelKey | translate }}
                </button>
              }
            </div>

            <p-datePicker
              [(ngModel)]="dateRangeValue"
              selectionMode="range"
              [showIcon]="true"
              [readonlyInput]="true"
              dateFormat="dd/mm/yy"
              [placeholder]="'STATISTICS.FILTERS.CUSTOM_RANGE' | translate"
              (ngModelChange)="onDateRangeChange()"
              appendTo="body"
              styleClass="vc-statistics__datepicker"
            />

            <div class="vc-statistics__comparison">
              <p-toggleSwitch
                [(ngModel)]="comparisonEnabled"
                (onChange)="toggleComparison()"
              />
              <span class="vc-statistics__comparison-label">{{
                "STATISTICS.FILTERS.COMPARE" | translate
              }}</span>
              @if (comparisonEnabled) {
                <p-select
                  [options]="comparisonOptions"
                  [(ngModel)]="selectedComparison"
                  optionValue="value"
                  (onChange)="onComparisonTypeChange()"
                  appendTo="body"
                  styleClass="vc-statistics__comparison-select"
                >
                  <ng-template pTemplate="selectedItem" let-option>
                    {{ option?.label | translate }}
                  </ng-template>
                  <ng-template pTemplate="item" let-option>
                    {{ option.label | translate }}
                  </ng-template>
                </p-select>
              }
            </div>
          </div>
        </div>

        @if (activeFilterCount > 0) {
          <div class="vc-statistics__active-filters">
            <span class="vc-statistics__active-filters-badge">
              {{
                "STATISTICS.FILTERS.ACTIVE_COUNT"
                  | translate: { count: activeFilterCount }
              }}
            </span>
            <button
              class="vc-statistics__clear-filters"
              (click)="filterService.resetEntityFilters()"
            >
              <i class="pi pi-times"></i>
              {{ "STATISTICS.FILTERS.CLEAR" | translate }}
            </button>
          </div>
        }
      </div>

      <div class="vc-page-toolbar vc-page-toolbar--stacked vc-statistics__toolbar vc-statistics__toolbar--mobile">
        <div class="vc-statistics__mobile-top">
          <div class="vc-statistics__mobile-actions">
            <button
              class="vc-statistics__mobile-btn"
              (click)="toggleMobileFilters()"
              [class.vc-statistics__mobile-btn--active]="showMobileFilters"
            >
              <i class="pi pi-filter"></i>
              @if (activeFilterCount > 0) {
                <span class="vc-statistics__mobile-badge">{{
                  activeFilterCount
                }}</span>
              }
            </button>
            <button class="vc-statistics__mobile-btn" (click)="toggleMobileNav()">
              <i class="pi pi-bars"></i>
            </button>
          </div>
        </div>

        <!-- Mobile Nav Tabs -->
        <nav class="vc-statistics__mobile-nav">
          @for (item of navItems; track item.route) {
            <a
              class="vc-statistics__mobile-nav-item"
              [routerLink]="['./', item.route]"
              routerLinkActive="vc-statistics__mobile-nav-item--active"
              [routerLinkActiveOptions]="{ exact: item.route === 'dashboard' }"
            >
              <i class="pi" [ngClass]="item.icon"></i>
              <span>{{ item.labelKey | translate }}</span>
            </a>
          }
        </nav>

        <!-- Mobile Filters Panel -->
        @if (showMobileFilters) {
          <div class="vc-statistics__mobile-filters">
            <!-- Date Presets -->
            <div class="vc-statistics__mobile-filter-row">
              <span class="vc-statistics__mobile-filter-label">{{
                "STATISTICS.FILTERS.PERIOD" | translate
              }}</span>
              <div class="vc-statistics__mobile-presets">
                @for (preset of datePresets; track preset.value) {
                  <button
                    class="vc-statistics__mobile-preset"
                    [class.vc-statistics__mobile-preset--active]="
                      filters?.activePreset === preset.value
                    "
                    (click)="setPreset(preset.value)"
                  >
                    {{ preset.labelKey | translate }}
                  </button>
                }
              </div>
            </div>

            <div class="vc-statistics__mobile-filter-row vc-statistics__mobile-period-row">
              <span class="vc-statistics__mobile-filter-label">{{
                "STATISTICS.FILTERS.MOVE" | translate
              }}</span>
              <div class="vc-statistics__mobile-period-controls">
                <button
                  class="vc-statistics__mobile-period-btn"
                  [disabled]="!canShiftPeriod"
                  (click)="shiftPeriod('previous')"
                >
                  <i class="pi pi-angle-left"></i>
                </button>
                <span class="vc-statistics__mobile-period-label">
                  {{ dateRangeLabel }}
                </span>
                <button
                  class="vc-statistics__mobile-period-btn"
                  [disabled]="!canShiftPeriod"
                  (click)="shiftPeriod('next')"
                >
                  <i class="pi pi-angle-right"></i>
                </button>
              </div>
            </div>

            <!-- Comparison Toggle -->
            <div class="vc-statistics__mobile-filter-row">
              <span class="vc-statistics__mobile-filter-label">{{
                "STATISTICS.FILTERS.COMPARE_MOBILE" | translate
              }}</span>
              <p-toggleSwitch
                [(ngModel)]="comparisonEnabled"
                (onChange)="toggleComparison()"
              />
            </div>
          </div>
        }
      </div>

      <!-- Mobile Nav Overlay -->
      @if (showMobileNav) {
        <div class="vc-statistics__mobile-overlay" (click)="closeMobileNav()">
          <div
            class="vc-statistics__mobile-menu"
            (click)="$event.stopPropagation()"
          >
            <div class="vc-statistics__mobile-menu-header">
              <h2>{{ "STATISTICS.FILTERS.SECTIONS" | translate }}</h2>
              <button
                class="vc-statistics__mobile-close"
                (click)="closeMobileNav()"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
            @for (item of navItems; track item.route) {
              <a
                class="vc-statistics__mobile-menu-item"
                [routerLink]="['./', item.route]"
                routerLinkActive="vc-statistics__mobile-menu-item--active"
                [routerLinkActiveOptions]="{ exact: item.route === 'dashboard' }"
                (click)="closeMobileNav()"
              >
                <i class="pi" [ngClass]="item.icon"></i>
                <div class="vc-statistics__mobile-menu-text">
                  <span>{{ item.labelKey | translate }}</span>
                  <small>{{ item.descriptionKey | translate }}</small>
                </div>
              </a>
            }
          </div>
        </div>
      }

      <!-- =====================================================================
           CONTENT
           ===================================================================== -->
      <div class="vc-statistics__content">
        <router-outlet></router-outlet>
      </div>
    </section>
  </main>
</div>
